import template from './delivery_manifest_all.html'
import controller from './delivery_manifest_all.controller'
import './delivery_manifest_all.scss'

let deliveryManifestAllComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default deliveryManifestAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/route_control/delivery_manifest_all/delivery_manifest_all.component.js